// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"2d00b917","453":"03346f77","907":"fbef095c"}[chunkId] + ".chunk.js";
};